module.exports = __webpack_public_path__ + "img/maquinas.8f4dd616.jpg";